import { buildSignInRedirect } from '@repo/api/auth/utils';
import type { ResponseError } from '@/api/trpc';
import { EXTENSION_ORIGIN } from '@repo/common/config';

export async function redirectToLoginPage(error?: Error | ResponseError) {
  if (typeof window === 'undefined') return;

  // Only the real extension parent has a REDIRECT_TO_LOGIN listener at EXTENSION_ORIGIN;
  // anywhere else our postMessage is dropped, so fall through to a normal redirect.
  if (window.self !== window.top && window.location.ancestorOrigins?.[0] === EXTENSION_ORIGIN) {
    // Inside the extension the login page can't render in the iframe, so the parent owns re-auth.
    console.debug('Forwarding redirectToLoginPage to parent frame', { error });
    window.parent.postMessage(
      { type: 'REDIRECT_TO_LOGIN', errorMessage: error?.message },
      EXTENSION_ORIGIN
    );
    return;
  }

  const pathname = window.location.pathname;
  // Preserve the user's current page so they can return after re-auth
  const callbackUrl = encodeURIComponent(window.location.href);
  const signInRedirectUri = buildSignInRedirect(pathname, callbackUrl);
  // Hard navigate to fully reset Better Auth's in-memory session store + React Query cache
  console.warn('Redirecting to sign-in page', { error });
  window.location.replace(signInRedirectUri);
}
